import { ToastOptions } from 'react-toastify';

import { ToastParams } from '@ui-core';

export const getToastId = (
  toastParams: ToastParams,
  options?: ToastOptions<unknown>
) => {
  if (options?.toastId) return options.toastId;
  if (typeof toastParams === 'string') return toastParams;
  return (
    toastParams.titleKey ??
    toastParams.textKey ??
    toastParams.text ??
    toastParams.buttonLabel
  );
};
